import { ElementType } from 'react';
import { Navigate, Route } from 'react-router';

import config from 'src/config';
import { tenantSubdomain } from 'src/modules/tenant/tenantSubdomain';

function renderPrivateRoute(routes, permissionChecker, location) {
  const renderComp = route => {
    if (!permissionChecker.isAuthenticated) {
      return <Navigate to='/auth/signin' state={{ from: location }} />;
    }

    if (!permissionChecker.isEmailVerified) {
      return <Navigate to='/auth/email-unverified' />;
    }

    if (
      ['multi', 'multi-with-subdomain'].includes(config.tenantMode) &&
      !tenantSubdomain.isSubdomain
    ) {
      if (permissionChecker.isEmptyTenant) {
        return <Navigate to='/auth/tenant' />;
      }
    } else {
      if (permissionChecker.isEmptyPermissions) {
        return <Navigate to='/auth/empty-permissions' />;
      }
    }

    if (!permissionChecker.match(route.permissionRequired)) {
      return <Navigate to='/403' />;
    }

    if (permissionChecker.isSuspendedTenant) {
      return <Navigate to='/auth/tenant/suspended' />;
    }

    if (route.checkPlanQuantity && !permissionChecker.hasPlanQuantity()) {
      return <Navigate to='/402' />;
    }

    const Component = route.component as ElementType;

    return <Component />;
  };

  return routes.map(route => {
    return (
      <Route key={route.path} path={route.path} element={renderComp(route)}>
        {route.subRoutes?.length
          ? renderPrivateRoute(route.subRoutes, permissionChecker, location)
          : null}
      </Route>
    );
  });
}

export default renderPrivateRoute;
